export const useFingerprint = () => {
  let fingerprint = localStorage.getItem("fingerprint");
  function generateRandomHexString(length: number) {
    if (typeof window !== "undefined") {
      const byteCount = Math.ceil(length / 2); // 2 hex characters per byte
      const randomBytes = new Uint8Array(byteCount);
      crypto.getRandomValues(randomBytes);
      let hexString = "";
      for (let i = 0; i < byteCount; i++) {
        hexString += randomBytes[i].toString(16).padStart(2, "0");
      }
      fingerprint = hexString.substr(0, length);
      return fingerprint;
    }
  }
  // Example usage: generate a 16-character long random hex string
  function getFingerprint() {
    return !fingerprint ? generateRandomHexString(16) : fingerprint;
  }
  return { getFingerprint };
};
